import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-member_kgu",
  "use": "icon-member_kgu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-member_kgu\"><defs><style type=\"text/css\"></style></defs><path d=\"M960 906.8H64v-75.6C64 701.5 169.5 596 299.2 596h425.6C854.5 596 960 701.5 960 831.2v75.6zM108.9 862h806.3v-30.8c0-105-85.4-190.4-190.4-190.4H299.2c-105 0-190.4 85.4-190.4 190.4V862zM512 587.6c-129.7 0-235.2-105.5-235.2-235.2S382.3 117.2 512 117.2s235.2 105.5 235.2 235.2S641.7 587.6 512 587.6z m0-425.6c-105 0-190.4 85.4-190.4 190.4S407 542.8 512 542.8s190.4-85.4 190.4-190.4S617 162 512 162z\" p-id=\"12986\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/member_kgu.svg
// module id = 4dvN
// module chunks = 17